import { ApiResponse, getSeoMetaDetails } from "../../../types";
import { getRequest } from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";
const api = getApiWithVersion(API_VERSION.V1);

export interface SeoMetaApiWrapper {
  status: boolean;
  result: getSeoMetaDetails ;
}

export interface SEO{

    getProductSEO(productCategoryId:number):Promise<ApiResponse<string> >;
    getSeoMetaDetails(pageCode: string): Promise<ApiResponse<SeoMetaApiWrapper >>;

}

const seo: SEO = {
    getProductSEO(productCategoryId ) {
        return getRequest(api.SEO_CONTENT, productCategoryId)
    },

     getSeoMetaDetails(pageCode) {
        return getRequest(api.SEO_META_DETAILS, pageCode);
    }
  


}

export default seo

